import { Flex } from '@shared/components';
import { RolesAndPermissionsPageHeader, RoleProvider } from '@user-management/role-management';
import { useParams } from '@user-management/router';
import { Outlet } from 'react-router-dom';

export default function RoleAndPermissionDetailsLayout() {
  const { appRoleId } = useParams('/roles-and-permissions/:appRoleId');

  return (
    <RoleProvider appRoleId={appRoleId}>
      <Flex sx={{ flexDirection: 'column', height: '100%' }}>
        <RolesAndPermissionsPageHeader />
        <Flex
          sx={(theme) => ({
            p: theme.spacing(6),
            flexGrow: 1,
            flexDirection: 'column',
          })}
        >
          <Outlet />
        </Flex>
      </Flex>
    </RoleProvider>
  );
}
